import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateJobLevelPayload {
  level_rank: number;
  name: string;
  status: number;
}

export interface UpdateJobLevelPaylod extends CreateJobLevelPayload {}

export const JOBLEVEL_QUERY_KEY = ["job-level"];
export const VIEW_JOBLEVEL_QUERY_KEY = ["view-job-level"];

export const joblevelService = {
  createJobLevel: async (payload: CreateJobLevelPayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/job-level", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  showJobLevel: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/job-level/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateJobLevel: async (id: number, payload: UpdateJobLevelPaylod) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(`api/job-level/${id}`, payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/job-level/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  viewAllJobLevel: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-job-level`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),

  getAllJobLevel: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/job-level`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
